import type { ReturnRequestStatusDto } from "@babackapp/private-api-client";

export type Stage = {
  key: keyof ReturnRequestStatusDto;
  translationKey: string;
};

export const STAGES: Stage[] = [
  { key: "created", translationKey: "returnRequests.details.timeline.created" },
  { key: "waiting", translationKey: "returnRequests.details.timeline.waiting" },
  { key: "approved", translationKey: "returnRequests.details.timeline.approved" },
  { key: "shipping", translationKey: "returnRequests.details.timeline.shipping" },
  { key: "shipped", translationKey: "returnRequests.details.timeline.shipped" },
  { key: "partiallyTreatedLogistician", translationKey: "returnRequests.details.timeline.partiallyTreatedLogistician" },
  { key: "treatedLogistician", translationKey: "returnRequests.details.timeline.treatedLogistician" },
  { key: "partiallyTreatedMerchant", translationKey: "returnRequests.details.timeline.partiallyTreatedMerchant" },
  { key: "treatedMerchant", translationKey: "returnRequests.details.timeline.treatedMerchant" },
  { key: "resolved", translationKey: "returnRequests.details.timeline.resolved" },
  { key: "cancelled", translationKey: "returnRequests.details.timeline.cancelled" },
  { key: "error", translationKey: "returnRequests.details.timeline.error" },
];

export type TimelineEntry = {
  key: keyof ReturnRequestStatusDto;
  translationKey: string;
  stageIndex: number;
  doneAt: number;
};

export function resolveTimelineEntries(
  status: ReturnRequestStatusDto,
): TimelineEntry[] {
  return STAGES.map((s, stageIndex) => ({
    ...s,
    stageIndex,
    doneAt: status[s.key].doneAt,
    isDone: status[s.key].done,
  }))
    .filter((s) => s.isDone)
    .sort((a, b) => b.doneAt - a.doneAt || b.stageIndex - a.stageIndex)
    .map(({ isDone: _isDone, ...e }) => e);
}
